module.exports = __webpack_public_path__ + "static/img/ForTheRecord.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ForTheRecord.png
// module id = bV8v
// module chunks = 1